<script setup lang="ts">
import PrimeSelectButton from 'primevue/selectbutton'

interface Props {
  modelValue?: unknown
  options?: unknown[]
  optionLabel?: string
  optionValue?: string
  optionDisabled?: string
  multiple?: boolean
  allowEmpty?: boolean
  disabled?: boolean
  invalid?: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: unknown): void
  (e: 'change', event: { originalEvent: Event; value: unknown }): void
}>()
</script>

<template>
  <PrimeSelectButton
    :modelValue="modelValue"
    :options="options"
    :optionLabel="optionLabel"
    :optionValue="optionValue"
    :optionDisabled="optionDisabled"
    :multiple="multiple"
    :allowEmpty="allowEmpty"
    :disabled="disabled"
    :invalid="invalid"
    @update:modelValue="(v) => emit('update:modelValue', v)"
    @change="(e) => emit('change', e)"
  >
    <template v-if="$slots.option" #option="slotProps">
      <slot name="option" v-bind="slotProps" />
    </template>
  </PrimeSelectButton>
</template>
